// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Box as InfoTitle, Box as Section, Tooltip } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { EMICountriesType } from '../types'

export interface EMIAgreementProps {
  country: EMICountriesType
}

export const EMIAgreement = ({ country }: EMIAgreementProps) => {
  const { t } = useTranslation()
  const FAQsUrl = process.env.EMI_FAQ_URL

  return (
    <Box flexCol gapY={16}>
      <Section flexCol gapY={4}>
        <InfoTitle flex gapX={4}>
          <p className="text-label text-foreground-prominent">
            {t(`emiAgreement.titleElectronicMoneyAccounts.${country}`)}
          </p>
          <Tooltip
            bodyContent={t(`emiAgreement.tooltipElectronicMoneyAccounts.${country}`)}
            type="complex"
          />
        </InfoTitle>
        <p className="text-foreground-subdued text-body-regular">
          {t(`emiAgreement.descriptionElectronicMoneyAccounts.${country}`)}{' '}
          <ExternalLink href={FAQsUrl}>{t('FAQs')}</ExternalLink>
        </p>
      </Section>

      <Section flexCol gapY={4}>
        <InfoTitle flex gapX={4}>
          <p className="text-label text-foreground-prominent">{t('emiAgreement.titleWhatsNext')}</p>
          <Tooltip bodyContent={t('emiAgreement.tooltipWhatsNext')} type="complex" />
        </InfoTitle>
        <p className="text-foreground-subdued text-body-regular">
          {t(`emiAgreement.descriptionWhatsNext.${country}`)}
        </p>
      </Section>
    </Box>
  )
}
